// extracted by mini-css-extract-plugin
export default {"modal":"mAZF70It--FeaturesModal_modal__70JtS","modal-content":"mAZF70It--FeaturesModal_modal-content__tUtEw","modalContent":"mAZF70It--FeaturesModal_modal-content__tUtEw"};